export default __webpack_public_path__ + "static/media/logo-new.79c07f13.png";